import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@core';

export interface SendContactMessageBody {
  readonly message: string;
}

@Injectable({ providedIn: 'root' })
export class ContactHttpService extends ApiService {
  send(body: SendContactMessageBody): Observable<void> {
    return this.httpClient.post<void>(`${this.env.apiUrl}/contact/message`, body);
  }
}
